import {ValidationModel} from '../../../shared/models/validation-results/validation.model';
import {UsedVehicleInquiryResponseModel} from './usedVehicleInquiryResponse.model';
import {UsedVehicleInquiryRequestModel} from './usedVehicleInquiryRequest.model';
/**
 * Replica of the server side MaxResponseObject.
 */
export class NMVTISMessageModel {

    public businessTransactionId: number;

    public isActionRequiredFromCSR: boolean;

    public isCompleted: boolean;

    public isClean: boolean;

    public isValid: boolean;

    public shouldAbandonTransation: boolean;

    public isSuccessful: boolean;

    public nmvtisResponse: UsedVehicleInquiryResponseModel;

    public nmvtisRequest: UsedVehicleInquiryRequestModel;

    public integrationInteractionMessageTypeId: number; // AAMVAIntegrationInteractionMessageTypeId

    public interactionManagerMessageId: number; // AAMVAIntegrationInteractionMessageId

    public interactionManagerMessageContent: string; // AAMVAIntegrationInteractionMessageContent

    public validationResults: ValidationModel;
}
